const observationPurification = [
  { 'flash-chromatography': 'The obtained crude product was purified via flash-chromatography on silica gel using cyclohexane/ethyl acetate 20:1 to 4:1.' },
  { hplc: 'The obtained crude product was purified via HPLC using MeCN/H₂O 10:1.' },
];

const solventsTL = [
  { cyclohexane: 'cyclohexane/ethyl acetate 20:1' },
  { 'CH<sub>2</sub>Cl<sub>2</sub>': 'CH₂Cl₂/MeOH 20:1' },
  { 'NEt<sub>3</sub>': 'cyclohexane/ethyl acetate 20:1 + 1% NEt₃' },
];

export { solventsTL, observationPurification };
